import { type ReactNode, createContext, useContext } from 'react';

type CacheEntry = {
  data: unknown;
  timestamp: number;
};

// There is a separate map for each session (e.g., per token)
type SessionCache = Map<string, CacheEntry>;

// Token-keyed cache store (plain Map so tokens can be compared by value)
const sessionCaches = new Map<string, SessionCache>();

const NO_TOKEN_KEY = '__no_token__';

// React Context so we can provide cache instance per app/provider
const ApiCacheContext = createContext<SessionCache | null>(null);

export const ApiCacheProvider = ({
  children,
  token,
}: {
  children: ReactNode;
  token?: string | null;
}) => {
  const cacheKey = token ?? NO_TOKEN_KEY;

  if (!sessionCaches.has(cacheKey)) {
    sessionCaches.set(cacheKey, new Map());
  }

  const cache = sessionCaches.get(cacheKey)!;

  return (
    <ApiCacheContext.Provider value={cache}>
      {children}
    </ApiCacheContext.Provider>
  );
};

const useApiCache = () => {
  return useContext(ApiCacheContext);
};

export default useApiCache;
